import React, { useState, useMemo, useEffect } from 'react'
import { Formik } from 'formik'
import { AvatarProfile, Wrapper, Panel, TextFieldIcon, SelectFieldIcon, TextAreaIcon } from '../../_components'
import Table from '../../_components/Table'
import { CircularProgress } from '@material-ui/core'
import  Axios  from 'axios'
import data from '../../fixtures'
import { capitalize } from '../../_utils'
import { useDispatch, useSelector } from 'react-redux'
import { addSMSNumbers } from '../../_slices/AppSlice'

const CheckField = record => {
  const dispatch = useDispatch() 
  const state = useSelector( ( state ) => {
    return {
      phones: state.application.phoneNumbers
    }
  } )

  const handleChange = evt => {
    const { checked } = evt.target
    if( checked ) {
      dispatch( addSMSNumbers( [ ...state.phones, record.row.original  ] ) )
    } 
    else {
      let Idx = state.phones.findIndex( item => item.id === record.value )
      let phones = state.phones.filter( ( val, index ) => {
        return index !== Idx
      })
    
     //update the state
     dispatch( addSMSNumbers( phones ) )
    }
  }
  return (
    <div class="block">
      <div class="mt-2">
        <label class="inline-flex items-center">
          <input type="checkbox" onChange={evt => handleChange(evt)} />
          <span class="ml-2">
            {``}
          </span>
        </label>
      </div>
    </div>
  )
}

const NameField = record => {
  let Name = record.value?.split(" ")

  return (
      <div className="flex flex-col items-start justify-center">
          <AvatarProfile bold label={`${capitalize( Name[ 0 ] )} ${capitalize( Name[ 1 ] )}`}/>
      </div>
  )
}

export default function SendSMS() {
  const state = useSelector( state => {
    return {
      selectedPhones: state.application.phoneNumbers
    }
  } )
  const farmerColumns = useMemo(
    () => [
      {
        Header: "#",
        accessor: "id",
        Cell: CheckField
      },
      {
        Header: "Registration No",
        accessor: "farmer_code"
      },
      {
          Header: "Name",
          accessor: "name",
          Cell: NameField
      },
      {
          Header: "Phone No",
          accessor: "phone"
      }
      ]
  )

  const [ tag, setSlug ] = useState( null )
  const [ activateBtn, setActiveButton ] = useState( false )
  const [ codes, setCodes ] = useState( [] )
  const [ submitting, setSubmitting ] = useState( false )
  const [ results, setResults ] = useState( [] )

  useEffect( () => {
    formatResponse()
  }, [])

  const fetchCodes = ( val ) => {
    if( val && val !== "" ) {
        setCodes( data.codes.filter( code => {
            return code.block === val
        } ) )
    }
  }

  const formatResponse = () => {
    const str = "ybs_autocreate_message=256773917523%3ASUBMITTED%3B256703019014%3ASUBMITTED&ybs_autocreate_status=OK"
    const xx = '{ybs_autocreate_message: { "256773917523": "SUBMITTED" } }'
    let a = str.indexOf( "=" )
    
  }

  const saveSMSRequest = async ( data ) => {
    try {
      const response = await Axios.post( `https://mis.nec.go.ug/api/auth/fiefoc_save_sms`, {
        sms: data.sms,
        farmer_category: data.farmer_category,
        scheme: localStorage.getItem( "scheme" ),
        created_by: localStorage.getItem( "email" ),
        message: data.description,
        message_status: "SUBMITTED",
        response: data.response 
      } )

      if( response.data ) {
        await localStorage.setItem( "name", "view_sms" )
        return window.location.reload()
      }
    } catch (error) {}
  } 

  const handleSubmit = async ( values ) => {
   if( results.length > 0  && values.message?.length > 0 ) {
    //Lets send SMS here
    const config = {
      ybsacctno: 1000119719,
      password: "BugHySmD",
      origin: 6969,
    }

    // const results = [
    //   { name: "King Isaac", phone: 256773917523, farmer_code: "KIN-2225" },
    //   { name: "Nsengiyunva King", phone: 256703019014, farmer_code: "KIN-2225"  }
    // ]
    //format phone numbers
    const phones = results.map( result => result.phone )
    const nostoreValue = 0;

    //hit the batch sms api
    //https://immense-sierra-91216.herokuapp.com/
    try {
        // const response = await Axios.post( `https://smgw1.yo.co.ug:9100/sendsms?ybsacctno=${config.ybsacctno}&password=${config.password}&origin=${config.origin}&sms_content=${values?.message}&destinations=${phones.join(",")}` )
        // const response = await Axios.post( `https://smgw1.yo.co.ug:8100/sendsms?ybsacctno=${config.ybsacctno}&password=${config.password}&origin=${config.origin}&sms_content=${values?.message}&destinations=${phones.join(",")}&nostore=${nostoreValue}` ) 
        // if( response.data ) {
        //   // await saveSMSRequest( {
        //   //   description: values.message,
        //   //   farmer_category: values.farmer_category,
        //   //   sms: results,
        //   //   scheme: localStorage.getItem( "scheme" ),
        //   //   response: response.data
        //   // } )
        //   console.log( 'result', response.data ) 
        //   // alert( "SMS has been sent to Farmer(s)" )
        // }
        const response = await Axios( {
          method: "post",
          url: `https://smgw1.yo.co.ug:8100/sendsms?ybsacctno=${config.ybsacctno}&password=${config.password}&origin=${config.origin}&sms_content=${values?.message}&destinations=${phones.join(",")}&nostore=${nostoreValue}`,
          withCredentials: false
        } )
        if( response.data ) {
          await saveSMSRequest( {
            description: values.message,
            farmer_category: values.farmer_category,
            sms: results,
            scheme: localStorage.getItem( "scheme" ),
            response: response.data
          } )
          alert( "SMS has been sent to Farmer(s)" )
        }
    } catch (error) {
          await saveSMSRequest( {
            description: values.message,
            farmer_category: values.farmer_category,
            sms: results,
            scheme: localStorage.getItem( "scheme" ),
            response: "NA"
          } )
      // alert( "SMS could not be sent. Server Error Occured." )
    }
   }
   else {
    alert( "Fill in all required fields.  You may not send SMS to Farmers without a  message body and their Respective Phone Numbers" )
   }
  }

  const fetchRespectiveFarmers = async ( values ) => {
    setSubmitting( true )
    try {
      const response = await Axios.post( `https://mis.nec.go.ug/api/auth/send_sms_fiefoc`, {
        scheme: localStorage.getItem( "scheme" )?.replace( "_", " " ),
        slug: tag,
        block_id: values?.block_id,
        group: values?.group_id,
        first_name: values?.name,
        last_name: values?.name
      } )
      if( response.data ) {
        let farmers = response.data?.records.map( farmer => {
          return {
            id: farmer.id,
            farmer_code: farmer.reg_number,
            name: `${farmer.first_name?.toUpperCase()} ${farmer.last_name?.toUpperCase()}`,
            phone: farmer.primary_contact,
            scheme: farmer.scheme
          }
        } )
        if( farmers.length >  0 ) {
          setResults( farmers )
        }
        else {
          alert( "No farmers were found please." )
        }
        setSubmitting( false )
      }
    } catch (error) {
      alert( "A Server error occured.")
      setSubmitting( false )
    }
  }

  const handleFields = async ( val ) => {
    if( val && val?.length > 0 ) {
      if( val === "farmers" || val === "blocks" || val === "groups" || val === "one_farmer" ) {
        await setSlug( val )
        await setActiveButton( true )
      }
    }
    
  }

  const handleFetchFarmers = async ( values ) => {
   if( tag === "farmers" ) {
    await fetchRespectiveFarmers()
   }
   if( tag === "blocks" ) {
    await fetchRespectiveFarmers( values )
   }
   if( tag === "groups" ) {
    await fetchRespectiveFarmers( values )
   }
   if( tag === "one_farmer" ) {
    await fetchRespectiveFarmers( values )
   }
  }

  return (
    <Wrapper>
      <div>
        <h2 className="md:text-base lg:text-base text-xs">
          {`Send Messages to Farmers`}
        </h2>
      </div>
      <Formik initialValues={{
        farmer_category: "",
        block_id: "",
        group_id: "",
        name: "",
        farmer_name: "",
        phone_number: "",
        message: "",
      }}
      onSubmit={handleSubmit}>
      { ( { values, handleBlur, handleChange, handleSubmit, isSubmitting } ) => {
          return (
          <form onSubmit={handleSubmit}>
            <Panel label="Fill in the form">
              <div className="grid grid-cols-2 gap-2 my-2">
                <SelectFieldIcon 
                  name="farmer_category"
                  handleChange={ evt => {
                    handleChange( evt )
                    setActiveButton( false )
                    setResults( [] )
                    handleFields( evt.target.value )
                  }} 
                  handleBlur={handleBlur}
                  value={values.farmer_category}
                  label="Farmer Category"
                  required={true}
                  question="Choose Category of Farmers"
                  options={data.farmerCategories.map( item => {
                      return { id: item.id, label: item.label, value: item.value }
                  } )}
                />

                <div />

                {( values.farmer_category === "block" || values.farmer_category === "group" ) &&
                ( 
                <>
                  <SelectFieldIcon 
                    name="block_id"
                    handleChange={( evt ) => {
                        handleChange( evt )
                        fetchCodes( evt.target.value )
                        handleFields( "blocks" )
                        if( tag === "groups" ) {
                          setActiveButton( false )
                        }
                    } } 
                    handleBlur={handleBlur}
                    value={values.block_id}
                    label="Block No"
                    required={true}
                    question="Block Number"
                    options={data.blocks.map( block => ( { id: block.id, label: block.label, value: block.value } ) )} 
                  /> 
                  {/* <div /> */}

                  {values.farmer_category === "group" && 
                  ( <SelectFieldIcon 
                    name="ffs_code"
                    handleChange={ ( evt ) => {
                      handleChange( evt )
                      handleFields( "groups" )
                    } } 
                    handleBlur={handleBlur}
                    value={values.ffs_code}
                    label="FFSG No."
                    required={true}
                    question="FFSG Number / Name"
                    options={codes.map( item => ( { id: item.code, label: item.code, value: item.code } ) )} 
                  /> ) }
                </>
                ) }

                {values.farmer_category === "farmer" && (
                  <>
                    <TextFieldIcon 
                    name="name"
                    handleChange={( evt ) => {
                      handleChange( evt )
                      handleFields( "one_farmer" )
                    }} 
                    handleBlur={handleBlur}
                    value={values.name}
                    label="Farmer Name"
                    required={false}
                    question="Enter the Farmer Name" />
                    <div />
                  </>
                  ) }

                {submitting ? (
                  <div className="flex items-center justify-center">
                    <CircularProgress size={24} color="primary" />
                  </div>
                ) : (
                  <div className="flex items-center justify-start my-5">
                    {activateBtn && ( results.length === 0 ) && (
                      <button type="button" 
                        className="rounded text-xs px-3 py-2 bg-red-500 text-white" onClick={() => handleFetchFarmers( values )}>
                        {`Fetch Farmer(s)`}
                      </button>
                    )}
                  </div>
                ) }
              </div>
            </Panel>

              
            {results.length > 0 &&
            ( <Panel label={`Selected Farmer(s)`}>
                <Table
                  rightButton={false}
                  rightBtnCallback={ () => {}}
                  rightButtonLabel={null}
                  label="Farmer List"
                  columns={farmerColumns}
                  data={results}
                  hidePagination={false}
                  hideDownload={true}
                />
              </Panel> ) }

              {( state.selectedPhones.length > 0 && results.length > 0 ) && 
                (<Panel label={`SMS Content Message`}>
                  <TextAreaIcon 
                    rows={5}
                    handleBlur={handleBlur}
                    handleChange={handleChange}
                    name="message"
                    value={values.message} 
                    label="Message"
                    question="Message Content"
                  />
                </Panel> 
              ) }
              {( results.length > 0 ) && ( 
                isSubmitting ? (
                  <div className="flex items-center justify-center">
                    <CircularProgress size={24} color="primary" />
                  </div>
                ) :
                <button type="submit" className="bg-green-700 px-5 py-2 mx-2 text-white text-sm rounded-sm">
                  {`Send Message(s)`}
                </button> 
              ) }
          </form>
          )
      } }
      </Formik>
    </Wrapper>
    
  )
    }
